import { defineMessages } from 'react-intl';

const scope = 'app.workspace.publications.assessmentDetails';

export default defineMessages({
  modalTitle: {
    id: `${scope}.modalTitle`,
    defaultMessage: 'Assessments & Learning Tools',
  },
  summaryFor: {
    id: `${scope}.summaryFor`,
    defaultMessage: 'Summary for "{title}"',
  },
  learningContext: {
    id: `${scope}.learningContext`,
    defaultMessage: 'Learning Context',
  },
  productId: {
    id: `${scope}.productId`,
    defaultMessage: 'Product ID',
  },
  productModel: {
    id: `${scope}.productModel`,
    defaultMessage: 'Product Model',
  },
  productVersion: {
    id: `${scope}.productVersion`,
    defaultMessage: 'Product Version',
  },
  sourceId: {
    id: `${scope}.sourceId`,
    defaultMessage: 'Source ID',
  },
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Title',
  },
  type: {
    id: `${scope}.type`,
    defaultMessage: 'Type',
  },
  dateCreated: {
    id: `${scope}.dateCreated`,
    defaultMessage: 'Date Created',
  },
  dateUpdated: {
    id: `${scope}.dateUpdated`,
    defaultMessage: 'Date Updated',
  },
  assessments: {
    id: `${scope}.assessments`,
    defaultMessage: 'Assessments',
  },
  totalItems: {
    id: `${scope}.totalItems`,
    defaultMessage: 'Total Items',
  },
  scored: {
    id: `${scope}.scored`,
    defaultMessage: 'Scored',
  },
  yes: {
    id: `${scope}.yes`,
    defaultMessage: 'Yes',
  },
  no: {
    id: `${scope}.no`,
    defaultMessage: 'No',
  },
  itemsCount: {
    id: `${scope}.itemsCount`,
    defaultMessage: '{count, plural, one {# item} other {# items}}',
  },
  pointsCount: {
    id: `${scope}.pointsCount`,
    defaultMessage: '{count, plural, one {# pt} other {# pts}}',
  },
  item: {
    id: `${scope}.item`,
    defaultMessage: 'Item {index}',
  },
  loading: {
    id: `${scope}.loading`,
    defaultMessage: 'Loading...',
  },
});
